module.exports = __webpack_public_path__ + "img/1449411600.db958832.jpg";